import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

/* Services */
import { AuthService } from '@app/components/authentication/services/auth.service';
import { Subscription } from 'rxjs';
import { UserService } from '@app/components/authentication/services/user.service';
import { CognitoUser } from '@aws-amplify/auth';
import { StorageMap } from '@ngx-pwa/local-storage';

@Component({
  selector: 'app-profile-menu',
  templateUrl: './profile-menu.component.html',
  styleUrls: ['./profile-menu.component.scss']
})
export class ProfileMenuComponent implements OnInit, OnDestroy {
  user: CognitoUser | any;
  currentTheme: string | undefined;

  /* Subscriptions */
  subscriptions: Subscription = new Subscription();

  constructor(public authService: AuthService, private userService: UserService, private router: Router, private storage: StorageMap) {
    const userSub = this.userService.user$.subscribe({
      next: (user: CognitoUser | any) => {
        this.user = user;
      }
    });
    this.subscriptions.add(userSub);
  }

  ngOnInit() {
    this.storage.watch('theme').subscribe(newTheme => {
      this.currentTheme = newTheme as string;
      document.body.className = `mat-typography mat-app-background ${newTheme as string}-theme`;
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  toggleTheme() {
    this.storage.set('theme', this.currentTheme == 'light' ? 'dark' : 'light').subscribe();
  }

  signOut() {
    localStorage.clear();
    this.authService.signOut().subscribe(res => {
      this.router.navigate(['/auth/signin']);
    });
  }

  goToProfileSettings() {
    this.router.navigate(['/profile']);
  }
}
